// extracted by mini-css-extract-plugin
export default {"root":"IconCheck_root__Gp+JQ"};